(ns app.front.view.group.admin.config.pre-con-expiration
  (:require [app.domain.application.model :as app-model]
            [app.domain.group.config.model :as config-model]
            [app.domain.workspace-notification.model :as workspace-notification-model]
            [app.front.ui :as ui]
            [app.front.ui.section :as section]
            [app.front.ui.select :as ui-select]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.config.notifications :as notification-config]
            [app.front.view.group.admin.target-time-config :as target-time-config]
            [core.front.config :as front-config]
            [core.front.event :refer [<sub]]
            [core.util.string :as str-util]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(defn pre-con-expiration-valid? [{:group.config/keys [pre-consultation-expires?
                                                      pre-consultation-expiration-value
                                                      pre-consultation-expiration-unit]}]
  (or (not pre-consultation-expires?)
      (and (some? pre-consultation-expiration-value)
           (some? pre-consultation-expiration-unit))))

(rf/reg-sub ::available-enforce-step-values
  :<- [::front-config/country]
  (fn [country [_ permit-type process-flow]]
    (let [no-deem-complete? (not (contains? app-model/process-flows-with-deem-complete
                                            [country permit-type process-flow]))]
      (cond->> config-model/pre-consultation-expiration-steps
        no-deem-complete? (remove #(= % :group-config.pre-consultation-expiration-enforce-step/deem-complete))))))

(defn view [{:keys [tr target *group-config parent-config level permit-type] :as ctx}]
  (let [{:group.config/keys [pre-consultation-expires?
                             pre-consultation-expiration-value
                             pre-consultation-expiration-enforce-step
                             process-flow]}                           @*group-config
        disabled                                                      (and (not pre-consultation-expires?)
                                                                           (-> parent-config :group.config/pre-consultation-expires? not))]
    [section/subsection
     {:title (tr [:group-admin/pre-con-expiration-title])}
     [:<>
      [ui/help-2
       {:color :white}
       (tr [:group-admin/pre-con-expiration-help])]
      [acommon/checkbox ctx :group.config/pre-consultation-expires?]
      (when (or (:group.config/pre-consultation-expiration-value parent-config)
                (:group.config/pre-consultation-expiration-unit parent-config))
        [:div.my-4
         (tr [:group-admin/pre-con-expiration-parent-value]
             [(:group.config/pre-consultation-expiration-value parent-config)
              (tr [(:group.config/pre-consultation-expiration-unit parent-config)])])])
      [:div.flex.flex-row
       [:div
        [ui/number-input (util/mmap {:id            (str "pre-con-expiration-value-" target)
                                     :label-text    (tr [:group.config/pre-consultation-expiration-value])
                                     :required      true
                                     :default-value pre-consultation-expiration-value
                                     :on-change     #(swap! *group-config
                                                            assoc
                                                            :group.config/pre-consultation-expiration-value
                                                            (some-> % futil/tval str-util/blank->nil parse-long))}
                                    disabled)]]
       [target-time-config/target-time-unit-select
        tr
        *group-config
        :group.config/pre-consultation-expiration-unit
        (tr [:group.config/pre-consultation-expiration-unit])
        (str "pre-con-expiration-unit-" target)
        disabled
        true]]
      (let [inherit?       (not= level :group-config.level/permit-type)
            enforce-values (<sub [::available-enforce-step-values permit-type process-flow])]
        (when (next enforce-values) ; show selector if more than one value
          [ui-select/select {:id           "select-expiration-enforce-step"
                             :label-text   (tr [:group.config/pre-consultation-expiration-enforce-step])
                             :values       enforce-values
                             :on-change    #(swap! *group-config
                                                   assoc
                                                   :group.config/pre-consultation-expiration-enforce-step
                                                   %)
                             :value        (or pre-consultation-expiration-enforce-step
                                               (and (not inherit?)
                                                    (or (:group.config/pre-consultation-expiration-enforce-step parent-config)
                                                        config-model/pre-consultation-expiration-default-step)))
                             :required     true
                             :disabled     disabled
                             :allow-empty? inherit?
                             :empty-text   (tr [:group-admin/inherit])
                             :val->str     #(tr [%])}]))
      [:div.flex.flex-row.items-end.my-2 [ui/help-2
                                          {:color :white}
                                          (tr [:group-admin/pre-consultation-expiration-notifications-help])]]
      [notification-config/editor
       {:title (tr [:group-admin/pre-consultation-expiration-notifications])
        :attr  :group.config/pre-consultation-expiration-notifications
        :types workspace-notification-model/pre-consultation-expiration-notification-types}
       ctx]]]))
